import BaseModal from 'components/Modals/BaseModal';
import SearchBar from 'components/SearchBar/SearchBar';
import { Button } from 'react-bootstrap';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function CameraSelectModal({
  open,
  onClose,
  search,
  setSearch,
  clearControls,
  deviceData,
  resolveAddCamera,
}) {
  const [params] = useSearchParams();

  useEffect(() => {
    setSearch(params.get('search') || '');
  }, [params]);

  return (
    <>
      <BaseModal
        size="lg"
        show={open}
        handleShow={() => onClose(false)}
        backgroundColor="white"
        closeButton={false}
        title={
          <div className="text-black d-flex flex-column flex-sm-row justify-content-between gap-3 w-100">
            <h3 className="fw-semibold fs-5 mb-0">Select Cameras</h3>
            <div className="d-flex">
              <SearchBar placeholder="Search" />
              <Button
                className="btn-transparent fs-6"
                style={{ color: '#1E374F' }}
                onClick={(e) => {
                  e.stopPropagation();
                  clearControls();
                }}
              >
                Clear
              </Button>
            </div>
          </div>
        }
      >
        <div className="text-black">
          <div className="d-flex flex-column overflow-auto">
            {deviceData &&
              deviceData?.connectedDevices
                ?.filter(
                  (device) =>
                    device.device_type === 'Overwatch VMS' &&
                    (search === '' || device.alias.toLowerCase().includes(search.toLowerCase())),
                )
                .map((camera) => (
                  <div className="border-bottom border-black" key={camera.id}>
                    <Button
                      className="btn-transparent text-black text-start rounded-0"
                      onClick={(e) => {
                        e.stopPropagation();
                        resolveAddCamera(camera);
                      }}
                    >
                      {camera.static_id} - {camera.alias}
                    </Button>
                  </div>
                ))}
          </div>
        </div>
      </BaseModal>
    </>
  );
}
